<p-dialog class="modal-dialog"
    [contentStyle]="contentStyleInput"
    [(visible)]="visible"
    [closeOnEscape]="true" 
    [dismissableMask]="dismissableMask"
    [modal]="true" 
    [draggable]="true"
    [style]="style" 
    [appendTo]="'body'"
    (onHide)="EmitHide()">
        <ng-template pTemplate="header"><ng-content select=".app-modal-header"></ng-content></ng-template>
        <ng-content select=".app-modal-body"></ng-content>
        <ng-template pTemplate="footer"><ng-content select=".app-modal-footer"></ng-content></ng-template>

</p-dialog>
